<div
  role="button"
  class="card info-card {{ customCardClass }}"
  [ngClass]="{
    'shadow': showShadow,
    'disabled-card-box': isDisabled,
    'cursor-pointer': showCursorPointer,
    'selected-card': isSelected
  }"
  [ngStyle]="cardStylesConfig"
  (click)="!isDisabled && onCardClick()"
  tabindex="0"
  [attr.aria-disabled]="isDisabled"
  [attr.aria-pressed]="isSelected"
  [attr.aria-label]="cardAriaLabel"
  (keydown.enter)="!isDisabled && onCardClick()"
  (keydown.space)="!isDisabled && onCardClick(); $event.preventDefault()"
>
  @if (showHeader) {
    <div class="card-header" [attr.aria-label]="'Card header'">
      <ng-content select="[cardHeader]"></ng-content>
    </div>
  }
  @if (showImage) {
    <div class="cardImage" [attr.aria-label]="imageAriaLabel || 'Card image'">
      <ng-content select="[cardImage]"></ng-content>
    </div>
  }
  @if (showBody) {
    <div class="card-body" [attr.aria-label]="bodyAriaLabel || 'Card body'">
      <ng-content select="[cardBody]"></ng-content>
    </div>
  }
  @if (showFooter) {
    <div class="card-footer" [attr.aria-label]="'Card footer'">
      <ng-content select="[cardFooter]"></ng-content>
    </div>
  }
</div>
